import { useMapEvents } from "react-leaflet";

/** Adapts Leaflet moveend to Google Maps-style onCameraChanged payload. */
export default function MapMoveHandler({ onCameraChanged }) {
  useMapEvents({
    moveend: (e) => {
      if (!onCameraChanged) return;
      const map = e.target;
      const c = map.getCenter();
      onCameraChanged({
        detail: {
          center: { lat: c.lat, lng: c.lng },
          zoom: map.getZoom(),
        },
      });
    },
  });
  return null;
}
